import { useState } from 'react';
import { Switch } from '@headlessui/react';
import { toast } from 'react-toastify';
import api from '../../services/httpService';

export default function BadgeAccessSettings({ user, currentUser, onSaved }) {
  const [saving, setSaving] = useState(false);
  if (!currentUser.access?.can_manage_badge_access || !user.access?.badge_access_eligible) return null;
  const save = async (field, value) => {
    if (field === 'enable_airport_bad_access_only' && value && user.profile?.enable_scheduler_access_only && !window.confirm('Switch this user from Scheduler only to Airport Badges only?')) return;
    setSaving(true);
    try {
      const { data } = await api.patch(`/api/users/${user.id}/`, { [field]: value, ...(field === 'enable_airport_bad_access_only' && value ? { enable_scheduler_access_only: false } : {}) });
      onSaved(data);
      toast.success('Airport Badge access updated');
      if (user.id === currentUser.id) window.dispatchEvent(new Event('lto-access-changed'));
    } catch (error) { toast.error(error.response?.data?.detail || 'Unable to update badge access'); }
    finally { setSaving(false); }
  };
  const admin = user.is_staff || user.is_superuser;
  const rows = [
    { label: 'Airport Badge', field: 'enable_airport_badge_access', checked: user.access.can_access_airport_badges, disabled: admin,
      description: admin ? 'Admins always have Airport Badges access.' : 'Add Airport Badges to this user’s existing LiveTakeoff access. Turning this off also clears Airport Badge Only.' },
    { label: 'Airport Badge Only', field: 'enable_airport_bad_access_only', checked: user.profile?.enable_airport_bad_access_only,
      description: 'Restrict this account to Airport Badges, including when it is an admin. Turning this off restores the account’s existing LiveTakeoff permissions.' },
  ];
  return <div className="rounded-xl border border-red-100 bg-red-50/40 px-4">
    {rows.map(row => <div className="flex items-center justify-between gap-5 py-5" key={row.field}>
      <div><div className="text-sm font-semibold text-slate-900">{row.label}</div><p className="mt-1 max-w-2xl text-sm text-slate-600">{row.description}</p></div>
      <Switch aria-label={row.label} checked={!!row.checked} disabled={saving || row.disabled} onChange={value => save(row.field, value)} className={`relative inline-flex h-7 w-12 shrink-0 rounded-full border-2 border-transparent ${row.checked ? 'bg-red-600' : 'bg-slate-300'} disabled:opacity-60 focus:ring-2 focus:ring-red-600 focus:ring-offset-2`}>
        <span className={`h-6 w-6 rounded-full bg-white shadow transition ${row.checked ? 'translate-x-5' : 'translate-x-0'}`} />
      </Switch>
    </div>)}
  </div>;
}
